export default "__VITE_ASSET__BfaGMcSc__"